import { Box, Button, Grid, Typography } from "@mui/material";

import heroImage from "../../../static/images/nam_universal_ii/nam-universal-ii-amplifier-placeholder.webp";
import interfaceImage from "../../../static/images/nam_universal_ii/nam-universal-ii-interface.webp";

const ProductHero = () => (
  <Box
    sx={{
      backgroundSize: "cover",
      position: "relative",
      p: 0,
      m: 0,
      flex: 100,
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      display: { xs: "block", md: "flex" },
      flexDirection: "column",
      minHeight: "100vh",
      pt: { xs: "84px", md: 0 },
      isolation: "isolate",
    }}
  >
    <img
      src={heroImage}
      alt=""
      aria-hidden="true"
      loading="eager"
      style={{
        width: "100%",
        height: "100%",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        position: "absolute",
        zIndex: 0,
        objectFit: "cover",
        objectPosition: "center",
        backgroundColor: "black",
        pointerEvents: "none",
      }}
    />
    <Box
      aria-hidden="true"
      sx={{
        zIndex: 1,
        position: "absolute",
        pointerEvents: "none",
        inset: 0,
        backgroundImage:
          "linear-gradient(rgba(0, 0, 0, 0.28) 0%, rgba(7, 13, 17, 0.36) 58%, #080b0d 96%)",
      }}
    />

    <Grid container justifyContent="center" className="fadeIn" sx={{ position: "relative", zIndex: 2 }}>
      <Grid item xs={12} md={10} sx={{ background: "none", p: 1, borderRadius: 10 }}>
        <Box className="nam-universal-ii__hero-window">
          <img
            src={interfaceImage}
            alt="NAM Universal II main plug-in window"
            width="100%"
            style={{ display: "block", marginTop: "-1.875%" }}
          />
        </Box>
        <>
          <Typography className="nam-universal-ii__hero-title" variant="h2" fontSize={30} sx={{ fontSize: 30 }}>
            NAM Universal II
          </Typography>
          <Typography sx={{ fontSize: { xs: "20px", md: "30px" } }}>
            <i>Your entire guitar and bass signal chain, in one universe.</i>
          </Typography>
          <Box
            sx={{
              mt: 3,
              columnGap: 5,
              rowGap: 2,
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              sx={{ width: { xs: "75%", md: "150px", background: "rgba(36, 36, 36, 0.5)" } }}
              variant="outlined"
              onClick={() => {
                const element = document.getElementById("overview");
                if (element) {
                  const y = element.getBoundingClientRect().top + window.pageYOffset - 64;
                  const reducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
                  window.scrollTo({ top: y, behavior: reducedMotion ? "auto" : "smooth" });
                }
              }}
            >
              Learn More
            </Button>
          </Box>
        </>
      </Grid>
    </Grid>
  </Box>
);

export default ProductHero;
